<template>
    <main class="article-page data-page">
        <div v-if="news" class="article-layout">
            <article class="newsdetail article-main">
                <header class="article-header">
                    <span class="article-category">{{news.category || '赛事研究'}}</span>
                    <h1>{{news.title}}</h1>
                    <div class="article-meta"><span>作者：{{news.author || '亚讯体育研究中心'}}</span><time>发布时间：{{news.time}}</time><span>独立观点，仅供参考</span></div>
                </header>
                <div class="content" v-html="news.content"></div>
                <footer class="pgnext">
                    <p v-if="news_prev"><small>上一篇</small><router-link :to="'/news/'+news_prev.id">{{news_prev.title}}</router-link></p>
                    <p v-if="news_next"><small>下一篇</small><router-link :to="'/news/'+news_next.id">{{news_next.title}}</router-link></p>
                </footer>
            </article>
            <aside class="article-sidebar">
                <section v-if="article_expert" class="article-side-card expert-intro-card">
                    <h2>本篇研究专家</h2>
                    <router-link :to="'/member/'+article_expert.id"><img :src="article_expert.portrait || defimg" @error="$event.target.src=defimg"><div><b>{{article_expert.name}}</b><span>{{article_expert.intro}}</span></div></router-link>
                    <div class="side-stats"><span><b>{{article_expert.seven_day_rate || 0}}%</b>7天胜率</span><span><b>{{article_expert.recommend_count || 0}}</b>历史分析</span></div>
                </section>
                <section v-if="more_news.length" class="article-side-card related-card">
                    <h2>相关推荐</h2>
                    <router-link v-for="item in more_news" :key="item.id" :to="'/news/'+item.id"><span>{{item.category}}</span><b>{{item.title}}</b><time>{{item.time}}</time></router-link>
                </section>
            </aside>
        </div>
        <div v-else class="panel-loading"><van-skeleton title row="10"/></div>
    </main>
</template>

<script>
    import defPortrait from '../assets/images/default-analyst-v3.jpg'
    import { applyArticleSeo } from '../utils/seo'
    export default {
        name: "news",
        data() {
            return {
                news: null,
                init: true,
                formPath: '',
                news_prev: null,
                news_next: null,
                article_expert: null,
                more_news: [],
                defimg: defPortrait
            }
        },
        watch:{
          '$route': function(v){
              let nid = v.params.nid
              this.news_prev = null
              this.news_next = null
              this.getData(nid)
              document.documentElement.scrollTop = 0
          }
        },
        activated() {
            let that = this,
                nid = this.$route.params.nid
            that.getData(nid)
        },
        methods: {
            getData(nid){
                let that = this
                that.$post(that.$api.news_info, {nid: nid}).then(function (res) {
                    if(res.news){
                        that.news = res.news
                    }
                    if(res.news_prev)
                        that.news_prev = res.news_prev
                    if(res.news_next)
                        that.news_next = res.news_next
                    that.article_expert = res.article_expert || null
                    if(that.article_expert && that.article_expert.portrait)
                        that.article_expert.portrait = that.$api.imgBaseUrl + that.article_expert.portrait
                    that.more_news = res.more_news || []
                    that.$nextTick(function () {
                        applyArticleSeo(that.news, that.article_expert)
                    })
                }).catch(function () {

                })
            },
            goBack(){
                let that = this
                this.$router.push({
                    path: that.formPath === '' ?'/':that.formPath
                })
            }
        }
    }
</script>

<style scoped>
</style>
